export default __webpack_public_path__ + "static/media/landing-home2.2295ecd8.png";